/**
 * Locking an address Google named (#478): in the firm's own words, at its own point.
 *
 * Reports → Адреси за заключване opens Settings → Адреси with the address as it was booked and
 * the door where it was booked. Saved unchanged, one of Google's would be Google's answer kept
 * for ever, which its terms do not allow; so *Save* waits until the name reads differently and
 * the door has moved — a different latitude or longitude, or both, however little. Our own
 * maps' answers may be locked as booked. The server holds the same rule (`FromGoogle` in Geo).
 */

import type { Schema } from '@taxi/api-client';

import { writeEntrance } from './entrances';

/** An address as Google named it, and where it was booked. */
export type GoogleNamed = Schema<'GoogleNamed'>;

/** What still has to change before an address Google named may be locked. */
export type GoogleUnmet = 'name' | 'pin';

/** The parts of a place being saved that the rule reads — a `PlaceDraft` is one. */
interface Saving {
  building: string;
  entrance: string | null;
  longitude: number;
  latitude: number;
}

export function stillGoogles(draft: Saving, named: GoogleNamed): GoogleUnmet[] {
  const unmet: GoogleUnmet[] = [];
  const line = draft.entrance == null ? draft.building : writeEntrance(draft.building, draft.entrance);

  if (sameLine(line, named.line)) unmet.push('name');
  if (draft.longitude === named.longitude && draft.latitude === named.latitude) unmet.push('pin');

  return unmet;
}

/** Whether two lines read the same, ignoring case and spacing — as the server compares them. */
function sameLine(a: string, b: string): boolean {
  const plain = (text: string) => text.trim().split(/\s+/).join(' ').toLocaleLowerCase('bg');

  return plain(a) === plain(b);
}
